var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_3515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 14.6666L1.33325 14.6666",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 14.6667V4.00004C11.3334 2.74296 11.3334 2.11442 10.9429 1.7239C10.5524 1.33337 9.92383 1.33337 8.66675 1.33337H7.33341C6.07634 1.33337 5.4478 1.33337 5.05727 1.7239C4.66675 2.11442 4.66675 2.74296 4.66675 4.00004V14.6667",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 14.6667V5.66671C14.0001 4.7304 14.0001 4.26225 13.7754 3.92595C13.6781 3.78036 13.5531 3.65536 13.4075 3.55808C13.0712 3.33337 12.6031 3.33337 11.6667 3.33337",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 14.6667V5.66671C2 4.7304 2 4.26225 2.22471 3.92595C2.32199 3.78036 2.44699 3.65536 2.59257 3.55808C2.92887 3.33337 3.39703 3.33337 4.33333 3.33337",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14.6666V12.6666",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 8H9.33341",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66675 7.33337H4.66675",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66675 9.33337H4.66675",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 7.33337H12.3333",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 9.33337H12.3333",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66675 5.33337H4.66675",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 5.33337H12.3333",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 10H9.33341",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.00008,
    cy: 4.66671,
    r: 1.33333,
    stroke: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_3515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirm);
export default __webpack_public_path__ + "static/media/firm.f9593514b57182dd4c73c8e56fe4a8c8.svg";
export { ForwardRef as ReactComponent };